module.exports = __webpack_public_path__ + "img/glassthicknessplus-174.ce5a5f19.svg";